import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Select,
  MenuItem,
} from '@material-ui/core'

const DELIMITER = '|'

class DeviceSensorInput extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    devices: PropTypes.object.isRequired,
  }

  static defaultProps = {
    value: {},
  }

  static styles = (theme) => ({
    sensor: {
      paddingLeft: theme.spacing(4),
    },
  })

  static mapStateToProps(state) {
    return {
      devices: state.devices,
    }
  }

  onChange = (e) => {
    const [deviceId, sensorId] = e.target.value.split(DELIMITER)
    this.props.onChange({ deviceId, sensorId })
  }

  value = (deviceId, sensorId) => (
    `${deviceId}${DELIMITER}${sensorId}`
  )

  sensorHtml = (deviceId, sensor) => (
    <MenuItem value={this.value(deviceId, sensor.id)} className={this.props.classes.sensor}>{sensor.id}</MenuItem>
  )

  // We fake option groups by using disabled menu item and manually adding padding to the children items
  // https://github.com/mui-org/material-ui/issues/2671
  deviceHtml = (device) => [
    <MenuItem value="" disabled>{device.id}</MenuItem>,
    device.sensors.map((sensor) => this.sensorHtml(device.id, sensor)),
  ]

  devices() {
    // TODO: should limit this by the current unitId, but where to get unitId from?
    return Object.values(this.props.devices)
  }

  render() {
    return (
      <Select
        value={this.value(this.props.value.deviceId, this.props.value.sensorId)}
        onChange={this.onChange}
        displayEmpty
      >
        {this.devices().map(this.deviceHtml)}
      </Select>
    )
  }
}

export default connect(
  DeviceSensorInput.mapStateToProps,
  DeviceSensorInput.mapDispatchToProps,
)(withStyles(DeviceSensorInput.styles)(DeviceSensorInput))
